export default __webpack_public_path__ + "static/media/aboutUsSectionImg2.dd38133e.jfif";